import { create as createStore } from "zustand"

const defaultState = {
  visible: false,
}

const store = createStore(() => defaultState)

export function useCartSidebarVisibile() {
  return store((state) => state.visible)
}

export function setCartSidebarVisible(visible: boolean) {
  store.setState({ visible })
}
